import { Routes} from '@angular/router';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export const routes: Routes = [
    {
        path: 'pages',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
        resolve: {
            // wait for translations to load
            ready: () => inject(TranslocoService).selectTranslate('common.languages.en')
        }
    },
    { path: '', redirectTo: 'pages', pathMatch: 'full' },
    { path: '**', redirectTo: 'pages' }
];
